import React, { useEffect, useState } from "react";
import Header from "../../../components/Header/Header";
import LeftSideBar from "../../../components/LeftSideBar/LeftSideBar";
import {
  Box,
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  InputBase,
  MenuItem,
  Select,
} from "@mui/material";
import Tables from "../../../components/Table/Table";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as acts from "../../../redux/administrator/actions";
import AdministratorHeader from "../../../components/Header/AdministratorHeader";
import "./outPutFormat.scss";
import TablePagination from "@mui/material/TablePagination";
import CustomizedSnackbars from "../../../components/Snackbars/CustomizedSnackbars";
import DateRangePicker from "../../../components/DateRangePicker";
import moment from "moment";
import TableSkeleton from "../../../components/Skeletons/TableSkeleton";
import ClearIcon from "@mui/icons-material/Clear";
import { action } from "../../../constants/action";
import { adminRoutes } from "../../../routes/routeConstants";
import Buttons from "../../../components/Controls/Buttons/Button";

const Index = () => {
  const listData = useSelector((state) => state?.admin?.outPutData?.data);
  const Dispatch = useDispatch();
  const navigate = useNavigate();
  const [pageCount, setPageCount] = useState(listData?.total_count || 0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [outputData, setOutputData] = useState([]);
  const [page, setPage] = useState(0);
  const apiStatus = useSelector((state) => state?.admin?.outPutData);
  const [message, setMessage] = useState("");
  const [err, setErr] = useState(false);
  const [fileType, setFileType] = useState("");
  const [status, setStatus] = useState("");
  const [sDate, setSDate] = useState("");
  const [eDate, setEDate] = useState("");
  const [type, setType] = useState("project");
  const [value, setValue] = useState("");
  const [fileNames, setFileName] = useState("");

  const [selectedRows, setSelectedRows] = useState([]);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [success, setSuccess] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");

  useEffect(() => {
    Dispatch(acts.ClearOutPutListApiStatus());
  }, []);

  useEffect(() => {
    const data = {
      page: page + 1,
      page_size: rowsPerPage,
      fileType,
      status,
      formattedStartDate: sDate,
      formattedEndDate: eDate,
      // ...(type !== null && {
      //   [type === "project" ? "projectName" : "batchName"]: value,
      // }),
      type,
      value,
      fileNames,
    };
    Dispatch(acts.getOutPutList(data));
  }, [Dispatch, rowsPerPage]);

  useEffect(() => {
    const data = {
      page: page + 1,
      page_size: rowsPerPage,
      fileType,
      status,
      formattedStartDate: sDate,
      formattedEndDate: eDate,
      // ...(type !== null && {
      //   [type === "project" ? "projectName" : "batchName"]: value,
      // }),
      type,
      value,
      fileNames,
    };
    Dispatch(acts.getOutPutList(data));
  }, []);

  useEffect(() => {
    //Success and error notification
    if (apiStatus && apiStatus !== undefined) {
      if (apiStatus?.apiError === true && apiStatus?.next === false) {
        setMessage(apiStatus?.message);
        setErr(true);
      }
    }
  }, [apiStatus]);

  useEffect(() => {
    setOutputData(listData?.data);
    setPageCount(listData?.total_count);
  }, [listData]);

  const handleChange = (event) => {
    setType(event.target.value);
    setValue("");
  };

  const handlePageChange = (event, value) => {
    setPage(value);
    Dispatch(
      acts.getOutPutList({
        page: value + 1,
        page_size: rowsPerPage,
        fileType,
        status,
        formattedStartDate: sDate,
        formattedEndDate: eDate,
        // ...(type !== null && {
        //   [type === "project" ? "projectName" : "batchName"]: value,
        // }),
        type,
        value,
        fileNames,
      }),
    );
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
    setPageCount(listData?.total_count);
  };

  const newScreenNavigatin = () => {
    Dispatch(acts.getDpDetails());
    // navigate("/data-point-details");
    navigate(`/${adminRoutes.dataPointDetails}`);
  };
  const filterByDate = (startDate, endDate) => {
    const formattedStartDate = startDate
      ? moment(startDate).format("YYYY-MM-DD")
      : "";
    const formattedEndDate = endDate
      ? moment(endDate).format("YYYY-MM-DD")
      : "";
    setSDate(formattedStartDate);
    setEDate(formattedEndDate);

    const data = {
      page: page + 1,
      page_size: rowsPerPage,
      fileType,
      status,
      formattedStartDate: formattedStartDate,
      formattedEndDate: formattedEndDate,
      // ...(type !== null && {
      //   [type === "project" ? "projectName" : "batchName"]: value,
      // }),
      type,
      value,
      fileNames,
    };
    Dispatch(acts.getOutPutList(data));
  };
  // const clear = () => {};
  const handleFileType = (event) => {
    setFileType(event.target.value);
  };
  const handleStatus = (event) => {
    setStatus(event.target.value);
  };

  const onChangeValue = (value) => {
    setValue(value);
  };

  const onChangeFileName = (value) => {
    setFileName(value);
  };

  const clearFileType = () => {
    setFileType("");
  };

  const clearStatus = () => {
    setStatus("");
  };

  const clearValue = () => {
    setValue("");
  };

  const clearFileName = () => {
    setFileName("");
  };

  const handleErrorClose = () => {
    setErr(false);
    setMessage("");
  };

  const handleRefresh = () => {
    const data = {
      page: page + 1,
      page_size: rowsPerPage,
      fileType,
      status,
      formattedStartDate: sDate,
      formattedEndDate: eDate,
      // ...(type !== null && {
      //   [type === "project" ? "projectName" : "batchName"]: value,
      // }),
      type,
      value,
      fileNames,
    };
    Dispatch(acts.getOutPutList(data));
  };

  const handleSubmitToSRM = async () => {
    try {
      setSubmitLoader(true);
      const res = await Dispatch(acts.submitFilesForSRM(selectedRows));
      setSubmitLoader(false);
      setSuccess(true);
      setSuccessMsg("Files submitted successfully to SRM!");
    } catch (err) {
      setSubmitLoader(false);
      setErr(true);
      setMessage("Failed to submit files to SRM. Please try again.");
    }
  };

  return (
    <>
      <Header />
      <Box className="manage-output-files">
        <Grid className="sidebar-main" container>
          <Grid item className="sidebar-container">
            <LeftSideBar page="sidebar" />
          </Grid>
          {/* <Grid className="manage-output-conatiner" item md={9} sm={8}> */}
          <Grid className="visualization-conatiner manage-output-conatiner">
            <AdministratorHeader
              text="Manage Output Files"
              outPutButton={"Data Point Details"}
              Click={newScreenNavigatin}
            />
            <Grid container spacing={0.5} className="input-wrap-container">
              <Grid item md={1}>
                <FormControl fullWidth>
                  <Select
                    className="b-0"
                    size="small"
                    // label="Select"
                    value={type}
                    onChange={handleChange}
                    inputProps={{ "aria-label": "Without label" }}
                  >
                    <MenuItem value="project" selected={true}>
                      {action.PROJECT}
                    </MenuItem>
                    <MenuItem value="batch">{action.BATCH}</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item md={2}>
                <div className="search">
                  {/* <div className="search-wrapper">
                    <SearchIcon />
                  </div> */}
                  <FormControl>
                    <InputBase
                      id="searchInput"
                      className="input-style"
                      placeholder={`${action.SEARCH}  ${
                        type === "project" ? action.PROJECT : action.BATCH
                      } `}
                      inputProps={{ "aria-label": "search" }}
                      onChange={
                        (event) => onChangeValue(event.target.value)
                        // onSearch(event.target.value, type)
                      }
                      value={value}
                    />
                    {value && (
                      <IconButton
                        onClick={() => clearValue()}
                        size="small"
                        style={{
                          position: "absolute",
                          top: "50%",
                          right: 1,
                          transform: "translateY(-50%)",
                        }}
                      >
                        <ClearIcon />
                      </IconButton>
                    )}
                  </FormControl>
                </div>

                {/* <SearchBar onSearch={(value, type) => onSearch(value, type)} /> */}
              </Grid>

              <Grid item md={2}>
                <div className="search">
                  {/* <div className="search-wrapper">
                    <SearchIcon />
                  </div> */}
                  <FormControl>
                    <InputBase
                      id="searchInput"
                      className="input-style"
                      placeholder={action.FILE_NAME_SEARCH}
                      inputProps={{ "aria-label": "search" }}
                      onChange={
                        (event) => onChangeFileName(event.target.value)
                        // onSearch(event.target.value, type)
                      }
                      value={fileNames}
                    />
                    {fileNames && (
                      <IconButton
                        onClick={() => clearFileName()}
                        size="small"
                        style={{
                          position: "absolute",
                          top: "50%",
                          right: 1,
                          transform: "translateY(-50%)",
                        }}
                      >
                        <ClearIcon />
                      </IconButton>
                    )}
                  </FormControl>
                </div>
              </Grid>

              <Grid item md={1.5}>
                <FormControl fullWidth size="small">
                  <Select
                    className="b-0"
                    size="small"
                    value={fileType}
                    onChange={handleFileType}
                    inputProps={{ "aria-label": "Without label" }}
                    displayEmpty
                  >
                    <MenuItem value="">File Type</MenuItem>
                    <MenuItem value="xlsx">XLSX</MenuItem>
                    <MenuItem value="pdf">PDF</MenuItem>
                    <MenuItem value="csv">CSV</MenuItem>
                    <MenuItem value="json">JSON</MenuItem>
                  </Select>
                  {fileType && (
                    <IconButton
                      onClick={() => clearFileType()}
                      size="small"
                      style={{
                        position: "absolute",
                        top: "50%",
                        right: 25,
                        transform: "translateY(-50%)",
                      }}
                    >
                      <ClearIcon />
                    </IconButton>
                  )}
                </FormControl>
              </Grid>

              <Grid item md={1.5}>
                <FormControl fullWidth>
                  <Select
                    className="b-0"
                    size="small"
                    value={status}
                    onChange={handleStatus}
                    inputProps={{ "aria-label": "Without label" }}
                    displayEmpty
                  >
                    <MenuItem value="">Status</MenuItem>
                    <MenuItem value="approved">Approved</MenuItem>
                    <MenuItem value="rejected">Rejected</MenuItem>
                    <MenuItem value="unapproved">Unapproved</MenuItem>
                  </Select>
                  {status && (
                    <IconButton
                      onClick={() => clearStatus()}
                      size="small"
                      style={{
                        position: "absolute",
                        top: "50%",
                        right: 25,
                        transform: "translateY(-50%)",
                      }}
                    >
                      <ClearIcon />
                    </IconButton>
                  )}
                </FormControl>
              </Grid>
              <Grid
                item
                md={2.5}
                className="z-999"
                sx={{ padding: "0px !important" }}
              >
                <DateRangePicker filterByDate={filterByDate} />
              </Grid>

              <Grid item md={1} sx={{ padding: "0px !important" }}>
                <Buttons
                  className="btn-search"
                  text={
                    submitLoader ? (
                      <>
                        <CircularProgress
                          size={18}
                          sx={{ color: "white", marginRight: 1 }}
                        />
                        Submitting...
                      </>
                    ) : (
                      "Submit to SRM"
                    )
                  }
                  onClick={handleSubmitToSRM}
                  disabled={submitLoader || selectedRows?.length === 0} // ✅ Disable when loading or no selection
                  sx={{
                    minWidth: 180,
                    opacity: submitLoader ? 0.8 : 1,
                    cursor: submitLoader ? "not-allowed" : "pointer",
                  }}
                ></Buttons>
              </Grid>
            </Grid>

            <Box className="manage-data-list">
              {apiStatus?.loader ? (
                <TableSkeleton />
              ) : (
                <Tables
                  data={outputData}
                  showDPCalculationMenu={true}
                  selectedRows={selectedRows}
                  setSelectedRows={setSelectedRows}
                />
              )}
            </Box>

            <Grid className="pagination-wrap">
              <TablePagination
                rowsPerPageOptions={[100, 200, 300, 500]}
                component="div"
                count={pageCount}
                page={parseInt(page)}
                onPageChange={handlePageChange}
                rowsPerPage={parseInt(rowsPerPage)}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Grid>
          </Grid>
        </Grid>
      </Box>
      {err && (
        <CustomizedSnackbars
          severity="error"
          state={err}
          text={message}
          handleClose={() => setErr(false)}
        />
      )}

      {success && (
        <CustomizedSnackbars
          severity="success"
          state={success}
          text={successMsg}
          handleClose={() => setSuccess(false)}
        />
      )}
    </>
  );
};

export default Index;
